<template>
  <div class="blog-footer-top">
    <a :href="blogDir" class="blog-footer-logo">
      <svg class="blog-footer-logo__icon">
        <use :xlink:href="getLogoId"></use>
      </svg>
    </a>
    <nav class="blog-footer-menu">
      <a v-for="item in blogMenu" :href="item.detailPage" class="blog-footer-menu__item">
        {{ item.name }}
      </a>
    </nav>
  </div>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';

import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const screenWidth = useScreenWidth();

const resultsStore = useResultsStore();
const blogDir = computed(() => resultsStore?.siteLanguages?.blogDir);
const blogMenu = computed(() => resultsStore?.blogMenu);

const getLogoId = computed(() =>
  screenWidth.value >= 768 ? '#svg-blog-logo' : '#svg-blog-logo-mobile'
);
</script>

<style lang="scss" scoped>
.blog-footer-top {
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  @include point-md {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.blog-footer-logo {
  margin-bottom: 32px;
  @include point-md {
    margin-bottom: 0;
  }
  &__icon {
    display: block;
    width: 60px;
    height: 73px;
    @include point-md {
      width: 60px;
      height: 96px;
    }
  }
}
.blog-footer-menu {
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  font-size: rem(12);
  text-transform: uppercase;
  &__item {
    display: block;
    padding: 4px 6px;
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 0;
    }
    &:not(:last-child) {
      margin-right: 16px;
    }
    &:first-child {
      background-color: #f5e6d8;
    }
    &:nth-child(2) {
      background-color: #d9e8d3;
    }
    &:nth-child(3) {
      background-color: #d8ecf5;
    }
    &:nth-child(4) {
      background-color: #f5d8dd;
    }
  }
}
</style>
